/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  Closed,
  Closure,
  Drawer,
  FiskalBreakerReset,
  FiskalClosureRequest,
  FiskalNotePrinted,
  FiskalOrderDocument,
  FiskalPrintNoteRequest,
  FiskalRawRequest,
  FiskalRawResult,
  FiskalReceiptPrinted,
  FiskalReceiptRequest,
  FiskalRegister,
  FiskalSettings,
  FiskalSettingsRequest,
  FiskalSharedSettingsRequest,
  FiskalSharedSettingsSaved,
  FiskalStornoRequest,
  FiskalStornoResult,
  FiskalTestResult,
  FiskalTotalMismatch,
  GetFiskalClosuresParams,
  GetFiskalDrawerStatusParams,
  GetFiskalReceiptsParams,
  GetFiskalTotalMismatchesParams,
  GetSettingsFiskalParams,
  KasaRequest,
  NewFiskalRegisterRequest,
  Page,
  Recovery,
  Unblock,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getGetSettingsFiskalUrl = (params?: GetSettingsFiskalParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/settings/fiskal?${stringifiedParams}`
    : `/api/v1/settings/fiskal`
}

/**
 * @summary One register's configuration
 */
export const getSettingsFiskal = async (
  params?: GetSettingsFiskalParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalSettings> => {
  return customFetch<FiskalSettings>(getGetSettingsFiskalUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsFiskalQueryKey = (params?: GetSettingsFiskalParams) => {
  return [`/api/v1/settings/fiskal`, ...(params ? [params] : [])] as const
}

export const getGetSettingsFiskalQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsFiskal>>,
  TError = unknown,
>(
  params?: GetSettingsFiskalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsFiskal>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsFiskalQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsFiskal>>> = ({ signal }) =>
    getSettingsFiskal(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsFiskal>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsFiskalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsFiskal>>
>
export type GetSettingsFiskalQueryError = unknown

export function useGetSettingsFiskal<
  TData = Awaited<ReturnType<typeof getSettingsFiskal>>,
  TError = unknown,
>(
  params: undefined | GetSettingsFiskalParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsFiskal>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsFiskal>>,
          TError,
          Awaited<ReturnType<typeof getSettingsFiskal>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsFiskal<
  TData = Awaited<ReturnType<typeof getSettingsFiskal>>,
  TError = unknown,
>(
  params?: GetSettingsFiskalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsFiskal>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsFiskal>>,
          TError,
          Awaited<ReturnType<typeof getSettingsFiskal>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsFiskal<
  TData = Awaited<ReturnType<typeof getSettingsFiskal>>,
  TError = unknown,
>(
  params?: GetSettingsFiskalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsFiskal>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One register's configuration
 */

export function useGetSettingsFiskal<
  TData = Awaited<ReturnType<typeof getSettingsFiskal>>,
  TError = unknown,
>(
  params?: GetSettingsFiskalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsFiskal>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsFiskalQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsFiskalUrl = () => {
  return `/api/v1/settings/fiskal`
}

/**
 * @summary Change one register's configuration
 */
export const putSettingsFiskal = async (
  fiskalSettingsRequest: FiskalSettingsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalSettings> => {
  return customFetch<FiskalSettings>(getPutSettingsFiskalUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fiskalSettingsRequest),
  })
}

export const getPutSettingsFiskalMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsFiskal>>,
    TError,
    { data: FiskalSettingsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsFiskal>>,
  TError,
  { data: FiskalSettingsRequest },
  TContext
> => {
  const mutationKey = ['putSettingsFiskal']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsFiskal>>,
    { data: FiskalSettingsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsFiskal(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsFiskalMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsFiskal>>
>
export type PutSettingsFiskalMutationBody = FiskalSettingsRequest
export type PutSettingsFiskalMutationError = unknown

/**
 * @summary Change one register's configuration
 */
export const usePutSettingsFiskal = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsFiskal>>,
      TError,
      { data: FiskalSettingsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsFiskal>>,
  TError,
  { data: FiskalSettingsRequest },
  TContext
> => {
  return useMutation(getPutSettingsFiskalMutationOptions(options), queryClient)
}
export const getPutSettingsFiskalSharedUrl = () => {
  return `/api/v1/settings/fiskal-shared`
}

/**
 * @summary Change the settings both registers share
 */
export const putSettingsFiskalShared = async (
  fiskalSharedSettingsRequest: FiskalSharedSettingsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalSharedSettingsSaved> => {
  return customFetch<FiskalSharedSettingsSaved>(getPutSettingsFiskalSharedUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fiskalSharedSettingsRequest),
  })
}

export const getPutSettingsFiskalSharedMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsFiskalShared>>,
    TError,
    { data: FiskalSharedSettingsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsFiskalShared>>,
  TError,
  { data: FiskalSharedSettingsRequest },
  TContext
> => {
  const mutationKey = ['putSettingsFiskalShared']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsFiskalShared>>,
    { data: FiskalSharedSettingsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsFiskalShared(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsFiskalSharedMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsFiskalShared>>
>
export type PutSettingsFiskalSharedMutationBody = FiskalSharedSettingsRequest
export type PutSettingsFiskalSharedMutationError = unknown

/**
 * @summary Change the settings both registers share
 */
export const usePutSettingsFiskalShared = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsFiskalShared>>,
      TError,
      { data: FiskalSharedSettingsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsFiskalShared>>,
  TError,
  { data: FiskalSharedSettingsRequest },
  TContext
> => {
  return useMutation(getPutSettingsFiskalSharedMutationOptions(options), queryClient)
}
export const getPostFiskalTestUrl = () => {
  return `/api/v1/fiskal/test`
}

/**
 * @summary Can the register be reached, and what does it say
 */
export const postFiskalTest = async (
  kasaRequest?: KasaRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalTestResult> => {
  return customFetch<FiskalTestResult>(getPostFiskalTestUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(kasaRequest),
  })
}

export const getPostFiskalTestMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFiskalTest>>,
    TError,
    { data?: KasaRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFiskalTest>>,
  TError,
  { data?: KasaRequest },
  TContext
> => {
  const mutationKey = ['postFiskalTest']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFiskalTest>>,
    { data?: KasaRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postFiskalTest(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostFiskalTestMutationResult = NonNullable<Awaited<ReturnType<typeof postFiskalTest>>>
export type PostFiskalTestMutationBody = KasaRequest | undefined
export type PostFiskalTestMutationError = unknown

/**
 * @summary Can the register be reached, and what does it say
 */
export const usePostFiskalTest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFiskalTest>>,
      TError,
      { data?: KasaRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFiskalTest>>,
  TError,
  { data?: KasaRequest },
  TContext
> => {
  return useMutation(getPostFiskalTestMutationOptions(options), queryClient)
}
export const getPostFiskalStornoUrl = () => {
  return `/api/v1/fiskal/storno`
}

/**
 * @summary Reverse a receipt
 */
export const postFiskalStorno = async (
  fiskalStornoRequest: FiskalStornoRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalStornoResult> => {
  return customFetch<FiskalStornoResult>(getPostFiskalStornoUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fiskalStornoRequest),
  })
}

export const getPostFiskalStornoMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFiskalStorno>>,
    TError,
    { data: FiskalStornoRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFiskalStorno>>,
  TError,
  { data: FiskalStornoRequest },
  TContext
> => {
  const mutationKey = ['postFiskalStorno']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFiskalStorno>>,
    { data: FiskalStornoRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postFiskalStorno(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostFiskalStornoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFiskalStorno>>
>
export type PostFiskalStornoMutationBody = FiskalStornoRequest
export type PostFiskalStornoMutationError = unknown

/**
 * @summary Reverse a receipt
 */
export const usePostFiskalStorno = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFiskalStorno>>,
      TError,
      { data: FiskalStornoRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFiskalStorno>>,
  TError,
  { data: FiskalStornoRequest },
  TContext
> => {
  return useMutation(getPostFiskalStornoMutationOptions(options), queryClient)
}
export const getPostFiskalResetBreakerUrl = () => {
  return `/api/v1/fiskal/reset-breaker`
}

/**
 * @summary Stop refusing calls to a register that is back
 */
export const postFiskalResetBreaker = async (
  kasaRequest?: KasaRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalBreakerReset> => {
  return customFetch<FiskalBreakerReset>(getPostFiskalResetBreakerUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(kasaRequest),
  })
}

export const getPostFiskalResetBreakerMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFiskalResetBreaker>>,
    TError,
    { data?: KasaRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFiskalResetBreaker>>,
  TError,
  { data?: KasaRequest },
  TContext
> => {
  const mutationKey = ['postFiskalResetBreaker']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFiskalResetBreaker>>,
    { data?: KasaRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postFiskalResetBreaker(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostFiskalResetBreakerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFiskalResetBreaker>>
>
export type PostFiskalResetBreakerMutationBody = KasaRequest | undefined
export type PostFiskalResetBreakerMutationError = unknown

/**
 * @summary Stop refusing calls to a register that is back
 */
export const usePostFiskalResetBreaker = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFiskalResetBreaker>>,
      TError,
      { data?: KasaRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFiskalResetBreaker>>,
  TError,
  { data?: KasaRequest },
  TContext
> => {
  return useMutation(getPostFiskalResetBreakerMutationOptions(options), queryClient)
}
export const getGetFiskalRegistersUrl = () => {
  return `/api/v1/fiskal/registers`
}

/**
 * @summary Every register this franchise has configured
 */
export const getFiskalRegisters = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalRegister[]> => {
  return customFetch<FiskalRegister[]>(getGetFiskalRegistersUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetFiskalRegistersQueryKey = () => {
  return [`/api/v1/fiskal/registers`] as const
}

export const getGetFiskalRegistersQueryOptions = <
  TData = Awaited<ReturnType<typeof getFiskalRegisters>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalRegisters>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFiskalRegistersQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiskalRegisters>>> = ({ signal }) =>
    getFiskalRegisters({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFiskalRegisters>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFiskalRegistersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFiskalRegisters>>
>
export type GetFiskalRegistersQueryError = unknown

export function useGetFiskalRegisters<
  TData = Awaited<ReturnType<typeof getFiskalRegisters>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalRegisters>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalRegisters>>,
          TError,
          Awaited<ReturnType<typeof getFiskalRegisters>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalRegisters<
  TData = Awaited<ReturnType<typeof getFiskalRegisters>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalRegisters>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalRegisters>>,
          TError,
          Awaited<ReturnType<typeof getFiskalRegisters>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalRegisters<
  TData = Awaited<ReturnType<typeof getFiskalRegisters>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalRegisters>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every register this franchise has configured
 */

export function useGetFiskalRegisters<
  TData = Awaited<ReturnType<typeof getFiskalRegisters>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalRegisters>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFiskalRegistersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostFiskalRegistersUrl = () => {
  return `/api/v1/fiskal/registers`
}

/**
 * Starts switched off and virtual - a register that went live the moment it was named would take the next receipt for a channel pointed at it. BACKEND.md §10A.65.
 * @summary Add a register
 */
export const postFiskalRegisters = async (
  newFiskalRegisterRequest: NewFiskalRegisterRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalRegister> => {
  return customFetch<FiskalRegister>(getPostFiskalRegistersUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(newFiskalRegisterRequest),
  })
}

export const getPostFiskalRegistersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFiskalRegisters>>,
    TError,
    { data: NewFiskalRegisterRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFiskalRegisters>>,
  TError,
  { data: NewFiskalRegisterRequest },
  TContext
> => {
  const mutationKey = ['postFiskalRegisters']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFiskalRegisters>>,
    { data: NewFiskalRegisterRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postFiskalRegisters(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostFiskalRegistersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFiskalRegisters>>
>
export type PostFiskalRegistersMutationBody = NewFiskalRegisterRequest
export type PostFiskalRegistersMutationError = unknown

/**
 * @summary Add a register
 */
export const usePostFiskalRegisters = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFiskalRegisters>>,
      TError,
      { data: NewFiskalRegisterRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFiskalRegisters>>,
  TError,
  { data: NewFiskalRegisterRequest },
  TContext
> => {
  return useMutation(getPostFiskalRegistersMutationOptions(options), queryClient)
}
export const getPostFiskalRecoverUrl = () => {
  return `/api/v1/fiskal/recover`
}

/**
 * @summary Close a document the register was left holding
 */
export const postFiskalRecover = async (
  kasaRequest?: KasaRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Recovery> => {
  return customFetch<Recovery>(getPostFiskalRecoverUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(kasaRequest),
  })
}

export const getPostFiskalRecoverMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFiskalRecover>>,
    TError,
    { data?: KasaRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFiskalRecover>>,
  TError,
  { data?: KasaRequest },
  TContext
> => {
  const mutationKey = ['postFiskalRecover']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFiskalRecover>>,
    { data?: KasaRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postFiskalRecover(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostFiskalRecoverMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFiskalRecover>>
>
export type PostFiskalRecoverMutationBody = KasaRequest | undefined
export type PostFiskalRecoverMutationError = unknown

/**
 * @summary Close a document the register was left holding
 */
export const usePostFiskalRecover = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFiskalRecover>>,
      TError,
      { data?: KasaRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFiskalRecover>>,
  TError,
  { data?: KasaRequest },
  TContext
> => {
  return useMutation(getPostFiskalRecoverMutationOptions(options), queryClient)
}
export const getPostFiskalReceiptUrl = () => {
  return `/api/v1/fiskal/receipt`
}

/**
 * @summary Print and register a receipt for an order
 */
export const postFiskalReceipt = async (
  fiskalReceiptRequest: FiskalReceiptRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalReceiptPrinted> => {
  return customFetch<FiskalReceiptPrinted>(getPostFiskalReceiptUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fiskalReceiptRequest),
  })
}

export const getPostFiskalReceiptMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFiskalReceipt>>,
    TError,
    { data: FiskalReceiptRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFiskalReceipt>>,
  TError,
  { data: FiskalReceiptRequest },
  TContext
> => {
  const mutationKey = ['postFiskalReceipt']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFiskalReceipt>>,
    { data: FiskalReceiptRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postFiskalReceipt(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostFiskalReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFiskalReceipt>>
>
export type PostFiskalReceiptMutationBody = FiskalReceiptRequest
export type PostFiskalReceiptMutationError = unknown

/**
 * @summary Print and register a receipt for an order
 */
export const usePostFiskalReceipt = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFiskalReceipt>>,
      TError,
      { data: FiskalReceiptRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFiskalReceipt>>,
  TError,
  { data: FiskalReceiptRequest },
  TContext
> => {
  return useMutation(getPostFiskalReceiptMutationOptions(options), queryClient)
}
export const getPostFiskalRawUrl = () => {
  return `/api/v1/fiskal/raw`
}

/**
 * @summary Send a raw protocol command, for diagnostics
 */
export const postFiskalRaw = async (
  fiskalRawRequest?: FiskalRawRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalRawResult> => {
  return customFetch<FiskalRawResult>(getPostFiskalRawUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fiskalRawRequest),
  })
}

export const getPostFiskalRawMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFiskalRaw>>,
    TError,
    { data?: FiskalRawRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFiskalRaw>>,
  TError,
  { data?: FiskalRawRequest },
  TContext
> => {
  const mutationKey = ['postFiskalRaw']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFiskalRaw>>,
    { data?: FiskalRawRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postFiskalRaw(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostFiskalRawMutationResult = NonNullable<Awaited<ReturnType<typeof postFiskalRaw>>>
export type PostFiskalRawMutationBody = FiskalRawRequest | undefined
export type PostFiskalRawMutationError = unknown

/**
 * @summary Send a raw protocol command, for diagnostics
 */
export const usePostFiskalRaw = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFiskalRaw>>,
      TError,
      { data?: FiskalRawRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFiskalRaw>>,
  TError,
  { data?: FiskalRawRequest },
  TContext
> => {
  return useMutation(getPostFiskalRawMutationOptions(options), queryClient)
}
export const getPostFiskalPrintNoteUrl = () => {
  return `/api/v1/fiskal/print-note`
}

/**
 * @summary Print a slip that is not a fiscal document
 */
export const postFiskalPrintNote = async (
  fiskalPrintNoteRequest: FiskalPrintNoteRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalNotePrinted> => {
  return customFetch<FiskalNotePrinted>(getPostFiskalPrintNoteUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fiskalPrintNoteRequest),
  })
}

export const getPostFiskalPrintNoteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFiskalPrintNote>>,
    TError,
    { data: FiskalPrintNoteRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFiskalPrintNote>>,
  TError,
  { data: FiskalPrintNoteRequest },
  TContext
> => {
  const mutationKey = ['postFiskalPrintNote']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFiskalPrintNote>>,
    { data: FiskalPrintNoteRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postFiskalPrintNote(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostFiskalPrintNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFiskalPrintNote>>
>
export type PostFiskalPrintNoteMutationBody = FiskalPrintNoteRequest
export type PostFiskalPrintNoteMutationError = unknown

/**
 * @summary Print a slip that is not a fiscal document
 */
export const usePostFiskalPrintNote = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFiskalPrintNote>>,
      TError,
      { data: FiskalPrintNoteRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFiskalPrintNote>>,
  TError,
  { data: FiskalPrintNoteRequest },
  TContext
> => {
  return useMutation(getPostFiskalPrintNoteMutationOptions(options), queryClient)
}
export const getPostFiskalEkasaUnblockUrl = () => {
  return `/api/v1/fiskal/ekasa-unblock`
}

/**
 * @summary Ask a locked register to unlock itself
 */
export const postFiskalEkasaUnblock = async (
  kasaRequest?: KasaRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Unblock> => {
  return customFetch<Unblock>(getPostFiskalEkasaUnblockUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(kasaRequest),
  })
}

export const getPostFiskalEkasaUnblockMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFiskalEkasaUnblock>>,
    TError,
    { data?: KasaRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFiskalEkasaUnblock>>,
  TError,
  { data?: KasaRequest },
  TContext
> => {
  const mutationKey = ['postFiskalEkasaUnblock']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFiskalEkasaUnblock>>,
    { data?: KasaRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postFiskalEkasaUnblock(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostFiskalEkasaUnblockMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFiskalEkasaUnblock>>
>
export type PostFiskalEkasaUnblockMutationBody = KasaRequest | undefined
export type PostFiskalEkasaUnblockMutationError = unknown

/**
 * @summary Ask a locked register to unlock itself
 */
export const usePostFiskalEkasaUnblock = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFiskalEkasaUnblock>>,
      TError,
      { data?: KasaRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFiskalEkasaUnblock>>,
  TError,
  { data?: KasaRequest },
  TContext
> => {
  return useMutation(getPostFiskalEkasaUnblockMutationOptions(options), queryClient)
}
export const getPostFiskalClosureUrl = () => {
  return `/api/v1/fiskal/closure`
}

/**
 * @summary Run a daily report, or move cash in or out of the drawer
 */
export const postFiskalClosure = async (
  fiskalClosureRequest: FiskalClosureRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Closed> => {
  return customFetch<Closed>(getPostFiskalClosureUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fiskalClosureRequest),
  })
}

export const getPostFiskalClosureMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFiskalClosure>>,
    TError,
    { data: FiskalClosureRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFiskalClosure>>,
  TError,
  { data: FiskalClosureRequest },
  TContext
> => {
  const mutationKey = ['postFiskalClosure']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFiskalClosure>>,
    { data: FiskalClosureRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postFiskalClosure(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostFiskalClosureMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFiskalClosure>>
>
export type PostFiskalClosureMutationBody = FiskalClosureRequest
export type PostFiskalClosureMutationError = unknown

/**
 * @summary Run a daily report, or move cash in or out of the drawer
 */
export const usePostFiskalClosure = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFiskalClosure>>,
      TError,
      { data: FiskalClosureRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFiskalClosure>>,
  TError,
  { data: FiskalClosureRequest },
  TContext
> => {
  return useMutation(getPostFiskalClosureMutationOptions(options), queryClient)
}
export const getGetFiskalTotalMismatchesUrl = (params?: GetFiskalTotalMismatchesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/fiskal/total-mismatches?${stringifiedParams}`
    : `/api/v1/fiskal/total-mismatches`
}

/**
 * The comparison nothing has ever made: `fiskal_documents.total_cents` is what the register printed and `orders.total` is what was stored, so a row here is an order somebody was charged a figure the order does not record. Reversed documents are excluded - their printed figure was withdrawn - and two cents of tolerance keeps rounding out of it. Nothing is resolved: which of the two figures was right is a decision for a person. Empty on any stack whose documents predate V59, which is correct rather than a fault - it fills as receipts are printed.
 * @summary Orders whose printed receipt and stored total disagree
 */
export const getFiskalTotalMismatches = async (
  params?: GetFiskalTotalMismatchesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalTotalMismatch[]> => {
  return customFetch<FiskalTotalMismatch[]>(getGetFiskalTotalMismatchesUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetFiskalTotalMismatchesQueryKey = (params?: GetFiskalTotalMismatchesParams) => {
  return [`/api/v1/fiskal/total-mismatches`, ...(params ? [params] : [])] as const
}

export const getGetFiskalTotalMismatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getFiskalTotalMismatches>>,
  TError = unknown,
>(
  params?: GetFiskalTotalMismatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalTotalMismatches>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFiskalTotalMismatchesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiskalTotalMismatches>>> = ({
    signal,
  }) => getFiskalTotalMismatches(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFiskalTotalMismatches>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFiskalTotalMismatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFiskalTotalMismatches>>
>
export type GetFiskalTotalMismatchesQueryError = unknown

export function useGetFiskalTotalMismatches<
  TData = Awaited<ReturnType<typeof getFiskalTotalMismatches>>,
  TError = unknown,
>(
  params: undefined | GetFiskalTotalMismatchesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalTotalMismatches>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalTotalMismatches>>,
          TError,
          Awaited<ReturnType<typeof getFiskalTotalMismatches>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalTotalMismatches<
  TData = Awaited<ReturnType<typeof getFiskalTotalMismatches>>,
  TError = unknown,
>(
  params?: GetFiskalTotalMismatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalTotalMismatches>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalTotalMismatches>>,
          TError,
          Awaited<ReturnType<typeof getFiskalTotalMismatches>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalTotalMismatches<
  TData = Awaited<ReturnType<typeof getFiskalTotalMismatches>>,
  TError = unknown,
>(
  params?: GetFiskalTotalMismatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalTotalMismatches>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Orders whose printed receipt and stored total disagree
 */

export function useGetFiskalTotalMismatches<
  TData = Awaited<ReturnType<typeof getFiskalTotalMismatches>>,
  TError = unknown,
>(
  params?: GetFiskalTotalMismatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalTotalMismatches>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFiskalTotalMismatchesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetFiskalReceiptsUrl = (params?: GetFiskalReceiptsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/fiskal/receipts?${stringifiedParams}`
    : `/api/v1/fiskal/receipts`
}

/**
 * @summary Every receipt this restaurant has issued
 */
export const getFiskalReceipts = async (
  params?: GetFiskalReceiptsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Page> => {
  return customFetch<Page>(getGetFiskalReceiptsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetFiskalReceiptsQueryKey = (params?: GetFiskalReceiptsParams) => {
  return [`/api/v1/fiskal/receipts`, ...(params ? [params] : [])] as const
}

export const getGetFiskalReceiptsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFiskalReceipts>>,
  TError = unknown,
>(
  params?: GetFiskalReceiptsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalReceipts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFiskalReceiptsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiskalReceipts>>> = ({ signal }) =>
    getFiskalReceipts(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFiskalReceipts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFiskalReceiptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFiskalReceipts>>
>
export type GetFiskalReceiptsQueryError = unknown

export function useGetFiskalReceipts<
  TData = Awaited<ReturnType<typeof getFiskalReceipts>>,
  TError = unknown,
>(
  params: undefined | GetFiskalReceiptsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalReceipts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalReceipts>>,
          TError,
          Awaited<ReturnType<typeof getFiskalReceipts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalReceipts<
  TData = Awaited<ReturnType<typeof getFiskalReceipts>>,
  TError = unknown,
>(
  params?: GetFiskalReceiptsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalReceipts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalReceipts>>,
          TError,
          Awaited<ReturnType<typeof getFiskalReceipts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalReceipts<
  TData = Awaited<ReturnType<typeof getFiskalReceipts>>,
  TError = unknown,
>(
  params?: GetFiskalReceiptsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalReceipts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every receipt this restaurant has issued
 */

export function useGetFiskalReceipts<
  TData = Awaited<ReturnType<typeof getFiskalReceipts>>,
  TError = unknown,
>(
  params?: GetFiskalReceiptsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalReceipts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFiskalReceiptsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetFiskalOrdersOrderIdDocumentsUrl = (orderId: number) => {
  return `/api/v1/fiskal/orders/${orderId}/documents`
}

/**
 * `fiskal_documents` has recorded one row per print and per reversal since §10A.191 and nothing could read it back: the receipts list reads `orders`, so it carries the order's *latest* stamp only. This is the sequence - printed, stornoed, re-issued - with what the register was told to print each time. Empty for an order whose documents predate V59, which is the honest state rather than a fault.
 * @summary Every fiscal document one order has had, oldest first
 */
export const getFiskalOrdersOrderIdDocuments = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<FiskalOrderDocument[]> => {
  return customFetch<FiskalOrderDocument[]>(getGetFiskalOrdersOrderIdDocumentsUrl(orderId), {
    ...options,
    method: 'GET',
  })
}

export const getGetFiskalOrdersOrderIdDocumentsQueryKey = (orderId: number) => {
  return [`/api/v1/fiskal/orders/${orderId}/documents`] as const
}

export const getGetFiskalOrdersOrderIdDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFiskalOrdersOrderIdDocumentsQueryKey(orderId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>> = ({
    signal,
  }) => getFiskalOrdersOrderIdDocuments(orderId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: orderId !== null && orderId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFiskalOrdersOrderIdDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>
>
export type GetFiskalOrdersOrderIdDocumentsQueryError = unknown

export function useGetFiskalOrdersOrderIdDocuments<
  TData = Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>,
  TError = unknown,
>(
  orderId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>,
          TError,
          Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalOrdersOrderIdDocuments<
  TData = Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>,
          TError,
          Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalOrdersOrderIdDocuments<
  TData = Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every fiscal document one order has had, oldest first
 */

export function useGetFiskalOrdersOrderIdDocuments<
  TData = Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalOrdersOrderIdDocuments>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFiskalOrdersOrderIdDocumentsQueryOptions(orderId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetFiskalDrawerStatusUrl = (params?: GetFiskalDrawerStatusParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/fiskal/drawer-status?${stringifiedParams}`
    : `/api/v1/fiskal/drawer-status`
}

/**
 * @summary What should be in the drawer right now
 */
export const getFiskalDrawerStatus = async (
  params?: GetFiskalDrawerStatusParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Drawer> => {
  return customFetch<Drawer>(getGetFiskalDrawerStatusUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetFiskalDrawerStatusQueryKey = (params?: GetFiskalDrawerStatusParams) => {
  return [`/api/v1/fiskal/drawer-status`, ...(params ? [params] : [])] as const
}

export const getGetFiskalDrawerStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getFiskalDrawerStatus>>,
  TError = unknown,
>(
  params?: GetFiskalDrawerStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalDrawerStatus>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFiskalDrawerStatusQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiskalDrawerStatus>>> = ({ signal }) =>
    getFiskalDrawerStatus(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFiskalDrawerStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFiskalDrawerStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFiskalDrawerStatus>>
>
export type GetFiskalDrawerStatusQueryError = unknown

export function useGetFiskalDrawerStatus<
  TData = Awaited<ReturnType<typeof getFiskalDrawerStatus>>,
  TError = unknown,
>(
  params: undefined | GetFiskalDrawerStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalDrawerStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalDrawerStatus>>,
          TError,
          Awaited<ReturnType<typeof getFiskalDrawerStatus>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalDrawerStatus<
  TData = Awaited<ReturnType<typeof getFiskalDrawerStatus>>,
  TError = unknown,
>(
  params?: GetFiskalDrawerStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalDrawerStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalDrawerStatus>>,
          TError,
          Awaited<ReturnType<typeof getFiskalDrawerStatus>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalDrawerStatus<
  TData = Awaited<ReturnType<typeof getFiskalDrawerStatus>>,
  TError = unknown,
>(
  params?: GetFiskalDrawerStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalDrawerStatus>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What should be in the drawer right now
 */

export function useGetFiskalDrawerStatus<
  TData = Awaited<ReturnType<typeof getFiskalDrawerStatus>>,
  TError = unknown,
>(
  params?: GetFiskalDrawerStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFiskalDrawerStatus>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFiskalDrawerStatusQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetFiskalClosuresUrl = (params?: GetFiskalClosuresParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/fiskal/closures?${stringifiedParams}`
    : `/api/v1/fiskal/closures`
}

/**
 * @summary Recent daily reports and cash movements
 */
export const getFiskalClosures = async (
  params?: GetFiskalClosuresParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Closure[]> => {
  return customFetch<Closure[]>(getGetFiskalClosuresUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetFiskalClosuresQueryKey = (params?: GetFiskalClosuresParams) => {
  return [`/api/v1/fiskal/closures`, ...(params ? [params] : [])] as const
}

export const getGetFiskalClosuresQueryOptions = <
  TData = Awaited<ReturnType<typeof getFiskalClosures>>,
  TError = unknown,
>(
  params?: GetFiskalClosuresParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalClosures>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFiskalClosuresQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiskalClosures>>> = ({ signal }) =>
    getFiskalClosures(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFiskalClosures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFiskalClosuresQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFiskalClosures>>
>
export type GetFiskalClosuresQueryError = unknown

export function useGetFiskalClosures<
  TData = Awaited<ReturnType<typeof getFiskalClosures>>,
  TError = unknown,
>(
  params: undefined | GetFiskalClosuresParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalClosures>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalClosures>>,
          TError,
          Awaited<ReturnType<typeof getFiskalClosures>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalClosures<
  TData = Awaited<ReturnType<typeof getFiskalClosures>>,
  TError = unknown,
>(
  params?: GetFiskalClosuresParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalClosures>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiskalClosures>>,
          TError,
          Awaited<ReturnType<typeof getFiskalClosures>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiskalClosures<
  TData = Awaited<ReturnType<typeof getFiskalClosures>>,
  TError = unknown,
>(
  params?: GetFiskalClosuresParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalClosures>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Recent daily reports and cash movements
 */

export function useGetFiskalClosures<
  TData = Awaited<ReturnType<typeof getFiskalClosures>>,
  TError = unknown,
>(
  params?: GetFiskalClosuresParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiskalClosures>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFiskalClosuresQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteFiskalRegistersKasaIdUrl = (kasaId: string) => {
  return `/api/v1/fiskal/registers/${kasaId}`
}

/**
 * Refuses while it has closures against it, while a sales channel points at it, or when it is the last one. BACKEND.md §10A.65.
 * @summary Remove a register
 */
export const deleteFiskalRegistersKasaId = async (
  kasaId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteFiskalRegistersKasaIdUrl(kasaId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteFiskalRegistersKasaIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFiskalRegistersKasaId>>,
    TError,
    { kasaId: string },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFiskalRegistersKasaId>>,
  TError,
  { kasaId: string },
  TContext
> => {
  const mutationKey = ['deleteFiskalRegistersKasaId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFiskalRegistersKasaId>>,
    { kasaId: string }
  > = (props) => {
    const { kasaId } = props ?? {}

    return deleteFiskalRegistersKasaId(kasaId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteFiskalRegistersKasaIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFiskalRegistersKasaId>>
>

export type DeleteFiskalRegistersKasaIdMutationError = unknown

/**
 * @summary Remove a register
 */
export const useDeleteFiskalRegistersKasaId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteFiskalRegistersKasaId>>,
      TError,
      { kasaId: string },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteFiskalRegistersKasaId>>,
  TError,
  { kasaId: string },
  TContext
> => {
  return useMutation(getDeleteFiskalRegistersKasaIdMutationOptions(options), queryClient)
}
